/**
 * Shared React Context instance and types for public client config.
 */

import { createContext } from 'react';

export interface PublicConfig {
  /** Equivalent of NODE_ENV variable */
  environment?: string;
  posthog?: {
    enabled: boolean;
    mode: 'disabled' | 'cloud' | 'self-hosted';
    host?: string;
    apiKey?: string;
    /** Reverse proxy URL to bypass ad blockers */
    proxyHost?: string;
  };
  faro?: {
    enabled: boolean;
    collectorUrl?: string;
    apiKey?: string;
  };
  /** Maximum upload file size in MB (configured via Vault, default 500) */
  maxUploadSizeMB?: number;
  /** CUPID deployment URL; absent when CUPID is not deployed. */
  cupidUrl?: string;
}

export const PublicConfigContext = createContext<PublicConfig | undefined>(undefined);
